import { transformToMenu } from '../../../menus/graphql/transformers'

const transformToDishReviewTask = dishReviewTask => ({
  ...dishReviewTask,
  menu: transformToMenu(dishReviewTask.menu),
})

export default transformToDishReviewTask
